export const isUser = user => user !== 'guest'; // TODO more sophisticated 

const commonOptions = {
    headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json',
    },
    credentials: 'include',
}
export const authenticateUser = async (username, password) =>{

  return fetch(`${process.env.REACT_APP_USERS_API_URL}/auth/login-pleo`, {
    method: 'POST', 
    ...commonOptions,
    body: JSON.stringify({
        "username": username,   
        "password": password,
    })
  })
}

export const registerUser = async (username, password) => {

    return fetch(`${process.env.REACT_APP_USERS_API_URL}/auth/signup-pleo`, {
        method: 'POST',
        ...commonOptions,
        body: JSON.stringify({
            "username": username,   
            "password": password,
            "favorites" : {launches: {}, pads: {}}
        })
    })
}

export const updateUserFavorites = async (username, favorites) => {

    return fetch(`${process.env.REACT_APP_USERS_API_URL}/user-favorites-pleo`, {
        method: 'PUT',
        ...commonOptions,
        body: JSON.stringify({
            "username": username,   
            "favorites" : favorites
        })
    })
}

export const getUserFavorites = async (username) => {
  return fetch(`${process.env.REACT_APP_USERS_API_URL}/user-favorites-pleo?` + new URLSearchParams({username: username}), {
      method: 'GET',
      ...commonOptions,
  })
}